import { render, staticRenderFns } from "./Detalhe.vue?vue&type=template&id=c7b06c50&scoped=true"
import script from "./Detalhe.vue?vue&type=script&lang=js"
export * from "./Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Detalhe.vue?vue&type=style&index=0&id=c7b06c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b06c50",
  null
  
)

export default component.exports